module.exports = __webpack_public_path__ + "static/img/barra_10.9529c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_10.png
// module id = cz1T
// module chunks = 1